import * as React from 'react';

export const SurveyPanel = React.memo(() => (
  <div
    id="survey-panel"
    className="ui-panel ui-panel-position-right ui-panel-display-overlay ui-body-inherit ui-panel-animate ui-panel-close"
  >
    <div className="ui-panel-inner" />
  </div>
));
